import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/hotel-order-detail',
            name: 'hotel-order-detail',
            component: () => import(/* webpackChunkName: "page-admin-hotel-order-manage-components-detail" */ `./1.0.1/index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "酒店订单"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单详情"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
